import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["backdrop", "content"]

    open() {
        this.backdropTarget.classList.add("modal-backdrop--visible")
        this.contentTarget.classList.add("modal-content--visible")

        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
        document.body.style.paddingRight = `${scrollBarWidth}px`
        document.body.classList.add("overflow-hidden")
    }

    close() {
        this.backdropTarget.classList.remove("modal-backdrop--visible")
        this.contentTarget.classList.remove("modal-content--visible")

        setTimeout(() => {
            document.body.style.paddingRight = ""
            document.body.classList.remove("overflow-hidden")
        }, 300)
    }

    backdropClick(event) {
        if (event.target === this.backdropTarget) {
            this.close()
        }
    }
}
